export default __webpack_public_path__ + "40b8c12304b62898d5359c7bfd252d5f.svg";